import { render, staticRenderFns } from "./ModalStemdoerDetail.vue?vue&type=template&id=5b5ab9be&scoped=true"
import script from "./ModalStemdoerDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalStemdoerDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalStemdoerDetail.vue?vue&type=style&index=0&id=5b5ab9be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ab9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5ab9be')) {
      api.createRecord('5b5ab9be', component.options)
    } else {
      api.reload('5b5ab9be', component.options)
    }
    module.hot.accept("./ModalStemdoerDetail.vue?vue&type=template&id=5b5ab9be&scoped=true", function () {
      api.rerender('5b5ab9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/stemdoer-detail/ModalStemdoerDetail.vue"
export default component.exports